import { Box, Button, Dialog, Typography } from "@mui/material";
import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import { ISuccessDialogProps } from "./interfaces/IDialogProps";
import { CheckCircleOutline } from "@mui/icons-material";

export const SuccessDialog: React.FC<ISuccessDialogProps> = ({
  open,
  content,
  onClose,
}) => {
  

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      title={""}
      PaperProps={{
        sx: {
          borderRadius: "30px",
          padding: "30px 25px",
          backgroundColor: "#ffffff",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
        },
      }}
    >
      {open && <ConfettiOverlay />}
      {/* Icon Container */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          background: "#3E73FF",
          width: 90,
          height: 90,
          borderRadius: "50%",
          margin: "0 auto",
          mb: 2,
          boxShadow: "0px 4px 20px rgba(62, 115, 255, 0.4)",
        }}
      >
        <CheckCircleOutline sx={{ fontSize: 55, color: "white" }} />
      </Box>

      {/* Title */}
      <Typography
        variant="body1"
        fontSize={'1.8rem'}
        textAlign="center"
        sx={{
          fontWeight: 700,
          color: "#3E73FF",
          mb: 1,
        }}
      >
        Success
      </Typography>

      {/* Description */}
      <Typography
        variant="body2"
        textAlign="center"
        fontSize={'1rem'}
        sx={{
          color: "gray",
          margin: "0 auto",
          mb: 3,
        }}
      >
        {content}
      </Typography>

      {/* Continue Button */}
      <Box textAlign="center">
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            background: "#3E73FF",
            width: "140px",
            padding: "10px 0",
            borderRadius: "30px",
            fontSize: "16px",
            textTransform: "none",
            boxShadow: "0px 4px 10px rgba(62, 115, 255, 0.4)",
            "&:hover": {
              background: "#335FDD",
            },
          }}
        >
          Continue
        </Button>
      </Box>
    </Dialog>
  );
};


const ConfettiOverlay = () => {
  useEffect(() => {
    const canvas = document.getElementById("confetti-canvas") as HTMLCanvasElement;
    if (!canvas) return;

    const myConfetti = confetti.create(canvas, {
      resize: true,
      useWorker: true,
    });

    myConfetti({
      particleCount: 150,
      spread: 280,
      origin: { y: 0.3 },
    });
  }, []);

  return (
    <canvas
      id="confetti-canvas"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 999999, // ABOVE dialog
      }}
    />
  );
};
